<template>
  <div class="panel">
    <header class="page-header">
      <div>
        <h1>全局设置</h1>
        <p>平台管理员专用 · 常用色板请在「色板配置」中维护</p>
      </div>
    </header>
    <div class="settings-form">
      <label class="field">
        <span>模板下载预警阈值（个/天）</span>
        <input v-model.number="threshold" type="number" min="1" />
      </label>
      <button class="btn-primary" :disabled="loading" @click="save">
        {{ loading ? '保存中...' : '保存设置' }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { usePlatformStore } from '@/composables/usePlatformStore';
import { configService } from '@/services/artApi';

const { showToast } = usePlatformStore();
const threshold = ref(50);
const loading = ref(false);
const CONFIG_KEY = 'systemConfigDownloadCount';

// 页面加载时查询配置
onMounted(async () => {
  await fetchConfig();
});

async function fetchConfig() {
  try {
    const response = await configService.get(CONFIG_KEY);
    if (response.success && response.result) {
      const value = Number(response.result.configValue);
      threshold.value = Number.isFinite(value) && value > 0 ? value : 50;
    } else {
      showToast(response.msg || '获取配置失败', 'warn');
    }
  } catch (error) {
    console.error('获取系统配置失败:', error);
    showToast(error?.message || '获取配置失败，请稍后重试', 'warn');
  }
}

async function save() {
  if (loading.value) return;
  
  const value = threshold.value;
  if (!Number.isFinite(value) || value < 1) {
    showToast('请输入有效的正整数', 'warn');
    return;
  }

  loading.value = true;
  try {
    const response = await configService.save({
      configKey: CONFIG_KEY,
      configValue: String(value),
    });
    
    if (response.success) {
      showToast('设置已保存', 'success');
    } else {
      showToast(response.msg || '保存失败', 'warn');
    }
  } catch (error) {
    console.error('保存系统配置失败:', error);
    showToast(error?.message || '保存失败，请稍后重试', 'warn');
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.panel { padding: 24px; }
.page-header h1 { font-size: 22px; font-weight: 700; }
.page-header p { font-size: 13px; color: var(--text-muted); margin-top: 4px; margin-bottom: 20px; }
.settings-form { max-width: 400px; display: grid; gap: 16px; }
.field { display: flex; flex-direction: column; gap: 6px; font-size: 13px; }
.field input { padding: 8px 12px; border-radius: var(--radius-sm); }
.btn-primary { padding: 8px 18px; border-radius: var(--radius-round); background: #2c2c2c; color: #fff; font-size: 13px; width: fit-content; }
</style>
